export const iconNames = [
  'alert-circle',
  'alert-triangle',
  'align-center',
  'align-left',
  'align-right',
  'archive',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'at-symbol',
  'ban',
  'bars-uneven-last',
  'bars-uneven-middle',
  'bars',
  'bell',
  'bold',
  'book-open',
  'bookmark',
  'calendar',
  'chart',
  'check-circle',
  'check-verified',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clapperboard',
  'clipboard-check',
  'clipboard',
  'clock',
  'close',
  'code-box',
  'code',
  'cog',
  'colors',
  'columns-01',
  'copy',
  'corners-in',
  'corners-out',
  'credit-card',
  'cube',
  'cursor-click',
  'device-mobile',
  'device-tablet',
  'document-ban',
  'document-left',
  'document-right',
  'document-text-folded-corner',
  'document-text',
  'dots-drag-and-drop',
  'dots-horizontal',
  'dots-vertical',
  'double-quotes-l',
  'download',
  'drawing-compass',
  'duplicate',
  'emotion-add',
  'emotion',
  'eye-off',
  'eye',
  'fire',
  'flag',
  'folder-plus',
  'folder',
  'font-size',
  'globe',
  'grid',
  'h-1',
  'h-2',
  'hand',
  'hash',
  'heart',
  'help-circle',
  'home',
  'image-add',
  'image-align-center',
  'image-align-left',
  'image-align-right',
  'image-float-left',
  'image-float-right',
  'image',
  'inbox',
  'info-circle',
  'italic',
  'key',
  'layout-header-sidebar',
  'layout-left',
  'layout-quadrants',
  'layout-top',
  'life-buoy',
  'light-bulb',
  'link-external',
  'link-unlink',
  'link',
  'list-ordered',
  'list-unordered',
  'location-marker',
  'lock-unlocked',
  'lock',
  'login',
  'logout',
  'mail-open',
  'mail',
  'message-text-circle',
  'message-text-square',
  'minus',
  'monitor',
  'moon',
  'paperclip',
  'pencil',
  'phone',
  'pin',
  'play-circle',
  'play',
  'plus',
  'puzzle',
  'refresh',
  'reverse-left',
  'reverse-right',
  'rows',
  'rss',
  'safari-line',
  'search',
  'selector',
  'send',
  'share',
  'shield-check',
  'shield-exclamation',
  'shield',
  'shut-down',
  'sliders',
  'spinner',
  'star',
  'strikethrough',
  'sun',
  'switch-horizontal',
  'tag',
  'terminal',
  'thumbs-down',
  'thumbs-up',
  'trash',
  'underline',
  'upload',
  'user-add',
  'user-ban',
  'user-left',
  'user-remove',
  'user-square',
  'user',
  'users',
  'x-circle',
  'zap',
  'zoom-in',
  'zoom-out',
] as const
export type IconName = (typeof iconNames)[number]
